import React, { useMemo, useState } from "react";
import "./UpdatePasswordPage.css";
import { updatePassword } from '../../_services/authServices'
import { useNavigate } from 'react-router-dom';
import Loader from '../../components/Loader';
import AlertBox from '../../components/AlertBox';
import { useUser } from "../../context/UserContext";

const UpdatePasswordPage = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [validated, setValidated] = useState(false);
  const [alert, setAlert] = useState({ show: false, message: "", type: "info" });
  
  const { logout } = useUser();

  const checks = useMemo(
    () => ({
      length: password.length >= 8,
      uppercase: /[A-Z]/.test(password),
      lowercase: /[a-z]/.test(password),
      number: /\d/.test(password),
      special: /[^A-Za-z0-9]/.test(password),
    }),
    [password]
  );

  const strength = Object.values(checks).filter(Boolean).length;

  const strengthLabel = () => {
    if (strength <= 2) return "Weak";
    if (strength === 3 || strength === 4) return "Medium";
    return "Strong";
  };

  const passwordsMatch =
    confirmPassword.length > 0 && password === confirmPassword;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (Object.values(checks).includes(false)) {
        alert("Password does not meet the required criteria.");
        return;
      }

      if (password !== confirmPassword) {
        alert("Passwords do not match.");
        return;
      }

      const result = await updatePassword(password);
      
      if (result.success === true) {
        setPassword("");
        
        logout();
        
        setTimeout(() => {
          setAlert({
            show: true,
            message: "Password update Successful. you will be redirected to the login page",
            type: "success",
          });

          setLoading(false);
          navigate(`/login`);
        }, 4000);
        
      }else{
        setTimeout(() => {
          setAlert({
            show: true,
            message: result.message,
            type: "error",
          });
          setLoading(false);
        }, 2000);
        
      }
    } catch (error) {
      setTimeout(() => {
        setAlert({
          show: true,
          message: error.message || `Something went wrong. Please try again.`,
          type: "error",
        });
      setLoading(false);
      }, 2000);
    } 
  };

  return (
    <div className="password-wrapper">
      <Loader show={loading} message="Processing, please wait..." />
      
      <AlertBox
        show={alert.show}
        message={alert.message}
        type={alert.type}
        onClose={() => setAlert({ ...alert, show: false })}
      />
      <div className="password-card">

        <h2>Create New Password</h2>

        <p>
          Your new password must be different from your previous password.
        </p>

        <form onSubmit={handleSubmit}>

          {/* <div className="form-group"> */}

            <div className="password-input mb-3">
                <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter new password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />

              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showConfirm ? <i className="bi bi-eye-slash"></i> : <i className="bi bi-eye"></i>}
              </button>
            </div>
          {/* </div> */}

          <div className="strength">
            <div className={`bar level-${strength}`}></div>
          </div>

          <div className="strength-label">
            Password Strength:
            <strong> {strengthLabel()}</strong>
          </div>

          <ul className="requirements">
            <li className={checks.length ? "valid" : ""}>
              ✓ Minimum 8 characters
            </li>

            <li className={checks.uppercase ? "valid" : ""}>
              ✓ One uppercase letter
            </li>

            <li className={checks.lowercase ? "valid" : ""}>
              ✓ One lowercase letter
            </li>

            <li className={checks.number ? "valid" : ""}>
              ✓ One number
            </li>

            <li className={checks.special ? "valid" : ""}>
              ✓ One special character
            </li>
          </ul>

          {/* <div className="form-group"> */}
            {/* <label>Confirm Password</label> */}

            <div className="password-input mb-3">
              <input
                type={showConfirm ? "text" : "password"}
                placeholder="Confirm password"
                value={confirmPassword}
                onChange={(e) =>
                  setConfirmPassword(e.target.value)
                }
              />

              <button
                type="button"
                onClick={() => setShowConfirm(!showConfirm)}
              >
                {showConfirm ? <i className="bi bi-eye-slash"></i> : <i className="bi bi-eye"></i>}
              </button>
            </div>

            {confirmPassword && (
              <small
                className={
                  passwordsMatch ? "match success" : "match error"
                }
              >
                {passwordsMatch
                  ? "✓ Passwords match"
                  : "✗ Passwords do not match"}
              </small>
            )}
          {/* </div> */}

          <button
            type="submit"
            disabled={
              !passwordsMatch ||
              Object.values(checks).includes(false)
            }
          >
            Update Password
          </button>

        </form>

          <p className="register-text">
            Changed your mind?{" "}
            <a href="/login">Login Instead</a>
          </p>
      </div>
    </div>
  );
};

export default UpdatePasswordPage;